'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import {
  Combobox,
  ComboboxInput,
  ComboboxOptions,
} from '@qogita/ui/v2/combobox'
import { InputIcon, InputRoot, InputSlot } from '@qogita/ui/v2/input'
import { useSuspenseQuery } from '@tanstack/react-query'
import { Suspense, useRef, useState } from 'react'
import { LoadingDots } from 'src/components/loading-dots'
import {
  isSearchTermTooShort,
  isValidSearchTerm,
  salesSearchQueryOptions,
} from 'src/core/data-layer/client-side/search'
import { useProgressBarRouter } from 'src/hooks/use-progress-bar-router'
import { useDebounce } from 'use-debounce'

import { SaleSearchResults } from './sales-search-results'

export function OrderSearch({ className }: { className?: string }) {
  const [searchTerm, setSearchTerm] = useState('')
  const [debouncedSearchTerm] = useDebounce(searchTerm, 500)
  const progressBarRouter = useProgressBarRouter()
  const inputRef = useRef<HTMLInputElement>(null)

  return (
    <Combobox
      className={className}
      onChange={(href) => {
        if (href) {
          setSearchTerm('')
          inputRef.current?.blur()
          progressBarRouter.push(href)
        }
      }}
    >
      <InputRoot>
        <ComboboxInput
          ref={inputRef}
          placeholder="Search your orders"
          aria-label="Search your orders"
          value={searchTerm}
          onChange={(event) => setSearchTerm(event.target.value)}
        />
        <InputSlot position="right">
          <InputIcon name="heroicons/outline/magnifying-glass" />
        </InputSlot>
      </InputRoot>
      {isValidSearchTerm(debouncedSearchTerm) ? (
        <ComboboxOptions>
          <Suspense fallback={<SearchResultsLoading />}>
            <SearchResults searchTerm={debouncedSearchTerm} />
          </Suspense>
        </ComboboxOptions>
      ) : isSearchTermTooShort(debouncedSearchTerm) ? (
        <ComboboxOptions>
          <SearchTermTooShort />
        </ComboboxOptions>
      ) : null}
    </Combobox>
  )
}

function SearchResults({ searchTerm }: { searchTerm: string }) {
  const salesSearchQuery = useSuspenseQuery(
    salesSearchQueryOptions({ searchTerm }),
  )

  if (salesSearchQuery.status === 'error') {
    // We don't use an error boundary because useSuspenseQuery doesn't throw an error
    return <SearchResultsErrorFallback />
  }

  if (salesSearchQuery.data.length === 0) {
    return <SearchResultsEmpty />
  }

  return <SaleSearchResults sales={salesSearchQuery.data} />
}

function SearchResultsLoading() {
  return (
    <div className="px-4 py-2">
      <LoadingDots />
    </div>
  )
}

function SearchResultsEmpty() {
  return <div className="px-4 py-2">No results found</div>
}

function SearchResultsErrorFallback() {
  return <div className="px-4 py-2">Error loading results</div>
}

function SearchTermTooShort() {
  return (
    <div className="text-low-emphasis px-4 py-2">
      Enter at least 3 characters
    </div>
  )
}
